import type { ResultadoDaExportacao } from '../types/negociacaoAssinaturasTypes';
import { formatarQuantidade } from './apresentacaoAssinaturas';
import { ROTULO_DO_FORMATO } from './rotulosAssinatura';

/**
 * O arquivo cortou linhas quando o core marcou `truncated` ou exportou menos do que a consulta
 * tinha (CA-15). O `truncated` vale sozinho: um status antigo no Redis pode vir sem as quantidades.
 */
export function arquivoFicouIncompleto(resultado: ResultadoDaExportacao | null): boolean {
  if (!resultado) return false;
  const { truncated, linhasExportadas, linhasElegiveis } = resultado;
  return (
    truncated ||
    (linhasExportadas !== null && linhasElegiveis !== null && linhasExportadas < linhasElegiveis)
  );
}

const ORIENTACAO_DO_ARQUIVO_INCOMPLETO =
  'Reduza a busca, os filtros ou o período e exporte novamente. Os totais da tabela consideram ' +
  'todas as pessoas encontradas.';

/**
 * Texto da tela 9, com as duas quantidades e o formato do arquivo gerado. Sem as quantidades, o
 * mesmo aviso sem os números, em vez de "0 das 0 pessoas".
 */
export function textoDoArquivoIncompleto(resultado: ResultadoDaExportacao): string {
  const formato = ROTULO_DO_FORMATO[resultado.formato];
  const { linhasExportadas, linhasElegiveis } = resultado;
  if (linhasExportadas === null || linhasElegiveis === null) {
    return (
      `O arquivo ${formato} não traz todas as pessoas encontradas, por causa do limite de ` +
      `linhas. ${ORIENTACAO_DO_ARQUIVO_INCOMPLETO}`
    );
  }
  return (
    `O arquivo ${formato} traz ${formatarQuantidade(linhasExportadas)} das ` +
    `${formatarQuantidade(linhasElegiveis)} pessoas encontradas, por causa do limite de linhas. ` +
    ORIENTACAO_DO_ARQUIVO_INCOMPLETO
  );
}

/**
 * Abre o arquivo numa aba nova e diz se ela abriu. A aba abre depois de até 180 s de espera, fora
 * do clique, e o bloqueador de pop-up pode recusá-la. `window.open(url, '_blank', 'noopener')`
 * devolve `null` mesmo quando abre (a spec manda), então não serve para detectar o bloqueio: abre
 * em branco, anula o `opener` na mão (a mesma proteção do `noopener`) e só então navega, como
 * `abrirCheckoutPagamento`.
 */
export function abrirArquivoEmNovaAba(endereco: string): boolean {
  const aba = window.open('', '_blank');
  if (!aba) return false;
  aba.opener = null;
  aba.location.href = endereco;
  return true;
}
